/** @param {number | string} size @param {object} [extra] */
export function fluentIconWrapperSx(size, extra = {}) {
  const n = typeof size === 'number' ? size : parseInt(String(size), 10)
  return {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    lineHeight: 0,
    fontSize: n,
    '& svg': { width: n, height: n, display: 'block' },
    ...extra,
  }
}

/** Icon sized via fontSize only (copy/check chevrons in blocks). */
export function fluentIconFontSizeSx(fontSize, extra = {}) {
  return {
    display: 'inline-flex',
    flexShrink: 0,
    fontSize,
    lineHeight: 0,
    '& svg': { fontSize, width: '1em', height: '1em' },
    ...extra,
  }
}
